import MobileHomeDraw from './MobileHomeDraw';

export default MobileHomeDraw;
